import { types } from "mobx-state-tree";

export const OrgRole = types.model("OrgRole", {
  id: types.maybe(types.string),
  user_id: types.number,
  org_id: types.string,
  role: types.string,
  created_at: types.string,
  updated_at: types.maybe(types.string),
  status: types.maybe(types.string),
});

export type IOrgRole = typeof OrgRole.Type;
